import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108d73ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-intransit-modal" }
const _hoisted_2 = { class: "confirm-order-content" }
const _hoisted_3 = { class: "confirm-order-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"8px"} }, "【ご確認ください】", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"16px"} }, "新規発注する直送注文に、在庫保有注文で処理中となっている商品が含まれる場合、処理中の商品を使用して発送しますか？", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-bottom":"8px"} }, "※処理中＝輸送中＋入庫済み＋検品中", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "※在庫保有注文で検品済みの商品は設定に関係なく直送注文に利用されます。", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { style: {"line-height":"20px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { style: {"line-height":"20px"} }
const _hoisted_14 = { style: {"line-height":"20px"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { style: {"line-height":"20px"} }
const _hoisted_17 = { class: "text-rt confirm-btns" }

import { t, lang } from '@/plugins/i18n'
import { ref, nextTick, toRaw, watch } from 'vue'
import { QuestionFilled } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { expose, emit }) {



const useOnTheWayStock = ref(true)
const visible = ref(false)

const open = (val) => {
    visible.value = true
    useOnTheWayStock.value = val ?? true
}
const cancel = () => {
    visible.value = false
}

const commit = () => {
    emit('success', useOnTheWayStock.value)
}

expose({
    open,
    cancel
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": "",
      onClose: cancel,
      draggable: "",
      width: 580
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_unref(lang) !== 'ja')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('是否使用在途库存')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_10))
          ]),
          _createVNode(_component_el_radio_group, {
            modelValue: useOnTheWayStock.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((useOnTheWayStock).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                label: true,
                size: "large",
                style: {"margin-bottom":"16px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('使用1')), 1),
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                label: false,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)('不使用1')), 1),
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('(如果您选择了「不使用」，则会为您采购成品库存不足的商品)')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: commit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('同意1')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})